//import
import React from 'react';
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import {MDBDataTable, MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import Lbl from "../../../../../../components/Label/Lbl";
import {Button as SementicBtn, Button, Form, Input} from "semantic-ui-react";
import {DatePicker, Icon as AntdIcon, Spin, TimePicker} from "antd";
import LabelInput from "../../../../../../components/Input/Input/TxtLbl";
import TxtAreaLbl from "../../../../../../components/Input/TextArea/TextAreaLbl";
import CropImageUploader from "../../../../../../components/CropImageUploader";
import MiniFileUploader from "../../../../../../components/FileUpload/MiniFileUploader/index";
import * as common from "../../../../../../const/Common/CommonFunc";
import * as util from "../../../../../../util/Validator";
import moment from "moment";
import * as actionCreator from "../../../../../../store/Action";
import {connect} from "react-redux";
import MiniUploderFrame from "../../../../../../components/FileUpload/MiniFileUploader/UploadFrames/index";

//vms-policy-css
import './Styles.css';
import Cookies from "js-cookie";
import axios_event from "../../../../../../axios/axios_eventtag";
import apiConfig from "../../../../../../axios/axios_api_services";
import swal from "sweetalert";
import uuid from 'uuid'
import are_you_sure_icon from "../../../../../../assets/img/sweet/question.svg";
import success_icon from "../../../../../../assets/img/sweet/success.svg";
import error_icon from "../../../../../../assets/img/sweet/cry.svg";
import ModernTimePicker from "../../../../../../components/TimePicker";
import * as timeutils from "../../../../../../util/TimeConvertor";
import LabelDropdown from "../../../../../../components/Dropdown/LabelDropdown/LabelDropdown";

//external functions
const {RangePicker} = DatePicker;

let s_date_for_disable = "";
let e_date_for_disable = "";

function disabledDate(current) {
  return moment(s_date_for_disable + " 23:59:59", 'YYYY-MM-DD HH:mm:ss').subtract(1, "days").endOf("day") > current ||
    current > moment(e_date_for_disable + " 23:59:59", 'YYYY-MM-DD HH:mm:ss').endOf("day");
}

//class
class App extends React.Component {

  //state
  state = {

    session_id: 0,

    //session details
    name: "",
    description: "",
    start_date: "",
    end_date: "",
    start_time: "",
    end_time: "",
    attachments: [],
    speakers: [],
    speaker_loader: false,
    speakers_list: [],
    search_speaker_name: '',


    speaker_edit_obj: null,
    speaker_edit: false,
    speaker_id: '',
    speaker_name: "",
    speaker_designation: "",
    speaker_linkedin_url: "",
    speaker_linkedin_url_search: "",
    valid_linkedin_url: true,
    speaker_summary: "",
    speaker_img: "",

    s_visible: false,
    e_visible: false,
    speaker_name_field_disabled: false,
    isHiddenSpeakerSearch: false
  };

  // id: 0,
  // file: file,
  // name: fileName,
  // link: ""
  //name and description change handler
  onchangeHandler = name => event => {
    let value = event.target.value;
    switch (name) {
      case 'name':
        this.setState({
          name: value
        });
        break;
      case 'description':
        this.setState({
          description: value
        });
        break;
      case 'speaker_name':
        this.setState({
          speaker_name: value
        });
        break;
      case 'speaker_designation':
        this.setState({
          speaker_designation: value
        });
        break;
      case 'speaker_linkedin_url':
        if (value !== '') {
          let result = util.linkedInUrlValidator(value);
          if (!result) {
            this.setState({
              speaker_linkedin_url: value,
              valid_linkedin_url: true
            });
          } else {
            this.setState({
              speaker_linkedin_url: value,
              valid_linkedin_url: false
            });
          }
        } else {
          this.setState({
            speaker_linkedin_url: value,
            valid_linkedin_url: false
          })
        }
        break;
      case 'speaker_linkedin_url_search':
        this.setState({
          speaker_linkedin_url_search: value
        });
        break;
      case 'speaker_summary':
        this.setState({
          speaker_summary: value
        });
        break;
      default:
        break;
    }
  };
  setPdf = (file, fileName) => {
    let obj = {
      id: 0,
      file: file,
      name: fileName,
      link: ""
    };
    let attachments = this.state.attachments;
    attachments.push(obj);
    this.setState({attachments: attachments});
  };
  //start time
  startTimeOnChange = (time, timeString) => {
    this.setState({
      start_time: timeString + ":00",
    });
  };
  //end time
  endTimeOnChange = (time, timeString) => {
    this.setState({
      end_time: timeString + ":00",
    });
  };
  //date
  dateRangeOnChange = (date, dateString) => {
    if (dateString[0] !== "" || dateString[1] !== "") {
      let start = new Date(dateString[0]);
      let end = new Date(dateString[1]);
      start = (start.toISOString()).split("T")[0];
      end = (end.toISOString()).split("T")[0];
      this.setState({
        start_date: start,
        end_date: end
      });
    }
  };

  //$#$#
  dateOnChangeStart = (date, dateString) => {

    if (dateString !== null) {
      let start = new Date(dateString);
      this.setState({
        start_date: dateString,
      });
    }
  };
  dateOnChangeEnd = (date, dateString) => {

    if (dateString !== null) {
      let end = new Date(dateString);
      this.setState({
        end_date: dateString,
      });
    }
  };
  //$#$#

  //set speaker img temp
  setSpeakerImg = (img, convert) => {
    this.setState({
      speaker_img: convert
    });
  };
  //add speaker validations
  addSpeakerValidations = () => {
      this.state.speaker_name.trim() === '' ? common.notifyMessage("Please enter speaker name") :
      this.state.speaker_designation.trim() === '' ? common.notifyMessage("Please enter speaker's designation") :
        // this.state.speaker_linkedin_url.trim() === '' ? common.notifyMessage("Please enter speaker's LinkedIn URL") :
          this.state.valid_linkedin_url ? common.notifyMessage("Invalid speaker's LinkedIn URL") :
            this.state.speaker_summary.trim() === '' ? common.notifyMessage("Please enter speaker summary") :
              this.state.speaker_img.trim() === '' ? common.notifyMessage("Please upload speaker's image") :
                !this.state.speaker_edit ? this.checkSpeakerDuplicate() : this.editSpeaker();
  };

  //following function use to manage speakers
  //check speaker duplicates
  checkSpeakerDuplicate = () => {
    let result = true;
    if (this.state.speaker_id === 0) {
      this.addSpeaker();
    } else {
      for (let i = 0; i < this.state.speakers.length; i++) {
        if (this.state.speakers[i].speaker_id === this.state.speaker_id) {
          result = false;
          break;
        }
      }
      if (result) {
        this.addSpeaker();
      } else {
        common.notifyMessage("Speaker can't be duplicate")
      }
    }
  };
  attachRemove = (index) => {
    let attachments = this.state.attachments;
    let name = attachments[index].name;
    swal({
      className: "swal-reception-number-check",
      text: "Are you sure to remove attachment named " + name + " ?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Ok",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.attachRemove_(index, attachments);
          break;
        default:
          break;
      }
    });
  };
  attachRemove_ = (index, attachments) => {
    attachments.splice(index, 1);
    this.setState({
      attachments: attachments
    });
  };
  //add speaker
  addSpeaker = () => {
    let speaker = {
      speaker_id: this.state.speaker_id,
      name: this.state.speaker_name,
      linkedin_url: this.state.speaker_linkedin_url,
      designation: this.state.speaker_designation,
      image_url: this.state.speaker_img,
      speaker_profile: {
        speaker_id: this.state.speaker_id,
        speaker_profile_id: 0,
        name: this.state.speaker_name,
        designation: this.state.speaker_designation,
        image_url: this.state.speaker_img,
        speaker_summary: this.state.speaker_summary
      }
    };
    let speakers = this.state.speakers;
    speakers.push(speaker);
    this.setState({speakers: speakers});
    this.cleanSpeakerFields();
  };
  //clean speaker fields
  cleanSpeakerFields = () => {
    this.setState({
      speaker_edit_obj: null,
      speaker_edit: false,
      search_speaker_name: "",
      speaker_designation: "",
      speaker_linkedin_url: "",
      valid_linkedin_url: true,
      speaker_summary: "",
      speaker_img: "",
      speaker_linkedin_url_search: "",
      speaker_name: "",
      speakers_list: [],
      speaker_name_field_disabled: false,
      isHiddenSpeakerSearch: false
    });
  };
  //edit speaker
  modifySpeaker = (row, index) => {
    let obj = {row: row, index: index};
    this.setState({
      // speaker_id: row.speaker_id,
      speaker_edit_obj: obj,
      speaker_edit: true,
      speaker_name: row.speaker_profile.name,
      speaker_designation: row.speaker_profile.designation,
      speaker_linkedin_url: row.linkedin_url,
      valid_linkedin_url: false,
      speaker_summary: row.speaker_profile.speaker_summary,
      speaker_img: row.speaker_profile.image_url !== null ? row.speaker_profile.image_url : "",
      isHiddenSpeakerSearch: true
    });
  };

  editSpeaker = () => {
    swal({
      className: "swal-reception-number-check",
      text: "Are you sure to update this speaker's details?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Ok",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.editSpeaker_();
          break;
        default:
          break;
      }
    });
  };

  //modify speaker
  editSpeaker_ = () => {
    let speaker_id = this.state.speaker_edit_obj.row.speaker_id;
    let speaker_profile_id = this.state.speaker_edit_obj.row.speaker_profile.speaker_profile_id;
    let index = this.state.speaker_edit_obj.index;
    let speaker = {
      speaker_id: speaker_id,
      name: this.state.speaker_name,
      linkedin_url: this.state.speaker_linkedin_url,
      designation: this.state.speaker_designation,
      image_url: this.state.speaker_img,
      speaker_profile: {
        speaker_profile_id: speaker_profile_id,
        name: this.state.speaker_name,
        designation: this.state.speaker_designation,
        image_url: this.state.speaker_img,
        speaker_summary: this.state.speaker_summary
      }
    };
    let speakers = this.state.speakers;
    speakers.splice(index, 1);
    speakers.splice(index, 0, speaker);
    this.setState({speakers: speakers,isHiddenSpeakerSearch: false});
    this.cleanSpeakerFields();
    this.setState({speaker_edit_obj: null, speaker_edit: false});
  };
  //delete speaker
  deleteSpeaker = (index, value) => {
    if(value.rate) {
      common.warningAlert("You can't remove this speaker because speaker has rated", 1)
    } else {
      this.deleteSpeaker_(index);
    }
  };

  deleteSpeaker_ = (index) => {
    let name = this.state.speakers[index].speaker_profile.name;
    swal({
      className: "swal-reception-number-check",
      text: "Are you sure to remove this speaker named \'" + name + "\'?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Ok",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.deleteSpeaker__(index);
          break;
        default:
          break;
      }
    });
  };
  deleteSpeaker__ = (index) => {
    let speakers = this.state.speakers;
    speakers.splice(index, 1);
    this.setState({
      speakers: speakers
    });
    this.cleanSpeakerFields();
  };
  //validate session



  validateSession = (state, fin) => {

    let sub_s = this.props.subEventIdStart + " " +this.props.subEventStartTime;
    let sub_e = this.props.subEventIdEnd + " " +this.props.subEventEndTime;
    let ss = this.state.start_date + " " +this.state.start_time;
    let se = this.state.end_date + " " +this.state.end_time;

    this.state.name.trim() === '' ? common.notifyMessage("Please enter session name") :
      this.state.description.trim() === '' ? common.notifyMessage("Please enter session description") :
        (this.state.start_date === '') || (this.state.end_date === '') ? common.notifyMessage("Please enter session start date and end date") :
          this.state.start_time === '' ? common.notifyMessage("Please enter session start time") :
            this.state.end_time === '' ? common.notifyMessage("Please enter session end time") :
              (new Date(this.state.start_date)>new Date(this.state.end_date))?common.notifyMessage("Event start date can't greater than event end date") :
              ((new Date(this.state.start_date).getFullYear() === new Date(this.state.end_date).getFullYear() &&
                new Date(this.state.start_date).getMonth() === new Date(this.state.end_date).getMonth() &&
                new Date(this.state.start_date).getDate() === new Date(this.state.end_date).getDate()) &&
                (this.state.start_time >= this.state.end_time))
                ? common.notifyMessage("End time can't br greater than start time also, start time & end time can't " +
                "be same in same start date and end date") :
                (sub_s>ss)?
                  common.notifyMessage("Session start time and end time have to be within the sub-event time."):
                  (sub_e<ss)?
                    common.notifyMessage("Session start time and end time have to be within the sub-event time."):
                    (sub_s>se)?
                      common.notifyMessage("Session start time and end time have to be within the sub-event time."):
                      (sub_e<se)?
                        common.notifyMessage("Session start time and end time have to be within the sub-event time."):
                this.sendToBackEndRedirection(state, fin);
  };
  sendToBackEndRedirection = (state, fin) => {
    switch (state) {
      case 1:
        this.sendToBackEnd(fin);
        break;
      case 2:
        this.sendToBackEndUpdate(fin);
        break;
      default:
        break;
    }
  };
  sendToBackEnd = (fin) => {
    swal({
      title: "Are you sure to create session named " + this.state.name + "?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Ok",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.sendToBackEnd_(fin);
          break;
        default:
          break;
      }
    });
  };
  sendToBackEndUpdate = (fin) => {
    swal({
      title: "Are you sure to create session named " + this.state.name + "?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Ok",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.sendToBackEndUpdate_(fin);
          break;
        default:
          break;
      }
    });
  };
  //send to back end
  sendToBackEnd_ = (finState) => {
    let obj = {
      session_id: this.state.session_id,
      name: this.state.name,
      description: this.state.description,
      speech_topic: this.state.name,
      start_time: timeutils.YYYYMMDDHHMMSSLocalToUTCDateTime(this.state.start_date + " " + this.state.start_time),
      end_time: timeutils.YYYYMMDDHHMMSSLocalToUTCDateTime(this.state.end_date + " " + this.state.end_time),
      attachments: [],
      speakers: this.state.speakers
    };

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };
    axios_event.post(apiConfig.CREATE_SESSION({sub_event_id: this.props.subEventId, corporateId: corporateId}), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          let sessionId = response.data.content.session_id;
          let session = response.data.content;
          if (this.state.attachments.length !== 0) {
            this.sendBrochureToBackEnd(sessionId, session, this.state.attachments, 1, finState);
          } else {
            this.refreshData(null, session, 1);
            this.setState({isHiddenSpeakerSearch: false});
            swal({
              title: "The session saved successfully!",
              icon: success_icon,
              closeOnClickOutside: false,
              buttons: {
                dangerMode: {
                  text: "Okay",
                  value: "action",
                  className: "okay-btn"
                }
              }
            })
              .then((value) => {
                switch (value) {
                  case "action":
                    this.changeModal(finState);
                    break;
                  default:
                }
              });
          }

        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackEnd_(finState)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });

  };

  changeModal = (fin) => {
    switch(fin) {
      case 'CLOSE':
        this.props.closeModal();
        break;
      case 'CONTINUE':
        this.setUpNewSession();
        break;
    }
  };

  setUpNewSession = () => {
    this.setState({
      session_id: 0,
      name: "",
      description: "",
      start_date: "",
      end_date: "",
      start_time: "",
      end_time: "",
      attachments: [],
      speakers: [],
      speaker_loader: false,
      speaker_edit_obj: null,
      speaker_edit: false,
      speaker_id: '',
      speaker_name: "",
      speaker_designation: "",
      speaker_linkedin_url: "",
      speaker_linkedin_url_search: "",
      valid_linkedin_url: true,
      speaker_summary: "",
      speaker_img: "",
      search_speaker_name: "",
      speakers_list: [],
      speaker_name_field_disabled: false
    });
  };

  sendToBackEndUpdate_ = (finState) => {

    let attach_string = [];
    let attach_obj = [];

    if (this.state.attachments) {
      if (this.state.attachments.length !== 0) {
        this.state.attachments.map((value, index) => {
          if (typeof value.file === 'string') {
            // attach_string.push(value);
            attach_string.push(
              {
                // pdf: value.link,
                pdf_name: value.name,
                pdf_url: value.link,
                speech_attachment_id: value.id
              }
            );
          } else {
            attach_obj.push(value);
          }
        });
      }
    }

    let obj = {
      session_id: this.state.session_id,
      name: this.state.name,
      description: this.state.description,
      speech_topic: this.state.name,
      start_time: timeutils.YYYYMMDDHHMMSSLocalToUTCDateTime(this.state.start_date + " " + this.state.start_time),
      end_time: timeutils.YYYYMMDDHHMMSSLocalToUTCDateTime(this.state.end_date + " " + this.state.end_time),
      attachments: attach_string,
      speakers: this.state.speakers
    };
    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };
    axios_event.patch(apiConfig.CREATE_SESSION({sub_event_id: this.props.subEventId, corporateId: corporateId}), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          let sessionId = response.data.content.session_id;
          let session = response.data.content;
          if (attach_obj.length !== 0) {
            this.sendBrochureToBackEnd(sessionId, session, attach_obj, 2);
          } else {
            this.refreshData(null, session, 1);
            this.setState({isHiddenSpeakerSearch: false});
            swal({
              title: "The session saved successfully!",
              icon: success_icon,
              closeOnClickOutside: false,
              buttons: {
                dangerMode: {
                  text: "Okay",
                  value: "action",
                  className: "okay-btn"
                }
              }
            })
              .then((value) => {
                switch (value) {
                  case "action":
                    this.changeModal(finState);
                    break;
                  default:
                }
              });
          }

        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackEndUpdate_(finState)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });

  };
  sendBrochureToBackEnd = (session_id, content, attach, state, finState) => {

    let brochure_message = "created";

    if (state === 2) {
      brochure_message = "updated";
    }

    this.props.spinnerHandler(true);

    let file_upload_state = false;
    let catch_error = false;
    let brochureUrl = null;
    let files = [];

    let formData = new FormData();
    formData.append('id', session_id);
    for (let i = 0; i < attach.length; i++) {
      formData.append('file', attach[i].file);
    }

    formData.append('type', 'ATTACHMENT');

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      'content-type': 'multipart/form-data'
    };
    axios_event.put(apiConfig.SEND_ATTACHMENT_FILES({corporateId: corporateId}), formData, {headers: headers})
      .then(response => {

        if (response.data.success) {

          file_upload_state = true;
          catch_error = false;
          let attch = response.data.fileUrls;
          this.refreshData(attch, content, 2);

        } else {

          common.warningAlert(response.data.message, 1);
          file_upload_state = false;
          catch_error = false;

        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendBrochureToBackEnd(session_id, content, attach, state, finState)
        } else {
          file_upload_state = false;
          catch_error = true;
        }
      })
      .finally(fin => {

        if (file_upload_state) {
          swal({
            title: "The session " + brochure_message + " successfully!",
            icon: success_icon,
            closeOnClickOutside: false,
            buttons: {
              dangerMode: {
                text: "Okay",
                value: "action",
                className: "okay-btn"
              }
            }
          })
            .then((value) => {
              switch (value) {

                case "action":
                  this.changeModal(finState);
                  break;
                default:
              }
            });

        } else {
          if (catch_error) {
            swal({
              title: "The event " + brochure_message + "successfully! But, Attachments upload failed.\"",
              icon: success_icon,
              closeOnClickOutside: false,
              buttons: {
                dangerMode: {
                  text: "Okay",
                  value: "action",
                  className: "okay-btn"
                }
              }
            })
              .then((value) => {
                switch (value) {
                  case "action":
                    this.changeModal(finState);
                    break;
                  default:
                }
              });

          } else {
            swal({
              title: "The event " + brochure_message + "successfully! But, Attachments upload failed.\"",
              icon: error_icon,
              closeOnClickOutside: false,
              buttons: {
                dangerMode: {
                  text: "Okay",
                  value: "action",
                  className: "okay-btn"
                }
              }
            })
              .then((value) => {
                switch (value) {
                  case "action":
                    this.changeModal(finState);
                    break;
                  default:
                }
              });
          }
        }
        this.props.spinnerHandler(false);
      });
  };
  refreshData = (attch, content, state) => {

    let attachment_array = [];
    switch (state) {
      case 1:
        if (content.attachments) {
          for (let i = 0; i < content.attachments.length; i++) {
            let attchment = content.attachments[i];
            let pdfId = attchment.speech_attachment_id;
            let pdfName = attchment.pdf_name !== null && attchment.pdf_name !== undefined ? attchment.pdf_name : "";
            let pdfUrl = attchment.pdf_url;
            let obj = {
              id: pdfId,
              file: pdfUrl,
              name: pdfName,
              link: pdfUrl
            };
            attachment_array.push(obj);
          }
        }
        break;
      case 2:
        if (content.attachments) {
          for (let i = 0; i < content.attachments.length; i++) {
            let attchment = content.attachments[i];
            let pdfId = attchment.speech_attachment_id;
            let pdfName = attchment.pdf_name !== null && attchment.pdf_name !== undefined ? attchment.pdf_name : "";
            let pdfUrl = attchment.pdf_url;
            let obj = {
              id: pdfId,
              file: pdfUrl,
              name: pdfName,
              link: pdfUrl
            };
            attachment_array.push(obj);
          }
        }
        if (attch) {
          for (let j = 0; j < attch.length; j++) {
            let attchment = attch[j];
            let pdfId = attchment.speech_attachment_id;
            let pdfName = attchment.pdf_name !== null && attchment.pdf_name !== undefined ? attchment.pdf_name : "";
            let pdfUrl = attchment.pdf_url;
            let obj = {
              id: pdfId,
              file: pdfUrl,
              name: pdfName,
              link: pdfUrl
            };
            attachment_array.push(obj);
          }
        }
        break;
      default:
        break;
    }

    content.attachments = attachment_array;
    let startDate = timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(content.start_time);
    let endDate = timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(content.end_time);
    let startDateArray = startDate.split(" ");
    let endDateArray = endDate.split(" ");
    let s_date = startDateArray[0];
    let e_date = endDateArray[0];
    let s_time = startDateArray[1];
    let e_time = endDateArray[1];
    if (content !== null) {
      this.setState({
        session_id: content.session_id,
        name: content.name,
        description: content.description,
        start_date: s_date,
        end_date: e_date,
        start_time: s_time,
        end_time: e_time,
        attachments: attachment_array,
        speakers: content.speakers,
      });
    }
  };

  isRegexExactMatch = (value, regexp) => {
    const res = value.match(regexp);
    return res && res[0] && res[0] === res.input;
  };

  /*searchSpeaker = () => {
    let url = this.state.speaker_linkedin_url_search.trim();
    // let regExpMatchArray = url.match(/^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/);

    const linkedInProfileURLRegExp =
      '(https?:\\/\\/(www.)?linkedin.com\\/(mwlite\\/|m\\/)?in\\/[a-zA-Z0-9_.-]+\\/?)';

    let regExpMatchArray = !!this.isRegexExactMatch(url, linkedInProfileURLRegExp);

    url === '' ? common.notifyMessage("Please enter speaker linkedin url for search") :
      !regExpMatchArray?common.notifyMessage("Please enter valid speaker linkedin url which starts with 'https://www.linkedin.com/in/' to search") :
      this.searchSpeaker_(url);
  };
  searchSpeaker_ = (url) => {
    let result = util.linkedInUrlValidator(url);
    !result ? common.notifyMessage("Please enter valid linkedin url for search") :
      this.searchSpeaker__(url);
  };
  searchSpeaker__ = (url) => {
    let obj = {
      linkedin_url: url
    };
    this.props.spinnerHandler(true);
    let corporateId = this.props.usr_obj.corporates[0].corporateId;
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };
    axios_event.patch(apiConfig.SEARCH_SPEAKER({corporateId: corporateId}), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.searchSpeakerDetailsSetOut(1, response.data.content);
        } else {
          this.searchSpeakerDetailsSetOut(0, null);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.searchSpeaker__(url);
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  searchSpeakerDetailsSetOut = (state, res) => {
    switch (state) {
      case 0:
        let linkedin = this.state.speaker_linkedin_url_search;
        this.setState({
          speaker_linkedin_url: linkedin,
          valid_linkedin_url: false,
          speaker_linkedin_url_search: "",
          speaker_id: 0,
          speaker_name: "",
          speaker_designation: "",
          speaker_img: "",
          speaker_summary: ""
        });
        break;
      case 1:
        this.setState({
          speaker_id: res.speaker_id,
          speaker_linkedin_url: res.linkedin_url,
          speaker_name: res.name,
          speaker_designation: res.designation,
          speaker_img: res.image_url !== null ? res.image_url : "",
          valid_linkedin_url: false,
          speaker_linkedin_url_search: "",
          speaker_summary: ""
        });
        break;
      default:
        break;
    }
  };*/
  //toggle
  toggle = () => {
  };

  componentDidMount() {
    let startTime = timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(this.props.subEventIdStart);
    let endTime = timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(this.props.subEventIdEnd);
    s_date_for_disable = startTime;
    e_date_for_disable = endTime;
    let currentSession = this.props.currentSession;

    if (currentSession !== null) {
      this.refreshData(null, currentSession, 1);
    }
  }


  clockVisibleChanger = (value) => {
    switch (value) {
      case "S":
        this.setState({
          s_visible: true,
          e_visible: false
        });
        break;
      case "E":
        this.setState({
          s_visible: false,
          e_visible: true
        });
        break;
      case "SV":
        this.setState({
          s_visible: false,
        });
        break;
      case "EV":
        this.setState({
          e_visible: false
        });
        break;
    }
  };

  handleSearchSpeaker = (e,{searchQuery}) => {
    this.setState({
      speakers_list:[],
      search_speaker_name: '',
      speaker_id: '',
      speaker_linkedin_url: "",
      speaker_designation: "",
      speaker_img: "",
      speaker_name: '',
      valid_linkedin_url: false,
      speaker_linkedin_url_search: "",
      speaker_summary: "",
      speaker_name_field_disabled: false
    });
    if (searchQuery.trim().length > 2) {
      const headers = { "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8") };
      let speakers_list = [];
      speakers_list.push({
        key: 0,
        text: searchQuery.trim(),
        value: 0,
        description: 'NEW USER'
      })
      axios_event.get(apiConfig.SEARCH_SPEAKER({searchValue:searchQuery.trim()}),{headers:headers})
        .then(response => {
          console.log(response);
          if (response.data.success) {
            let data = response.data.content;
            if (data.length !== 0) {
              data.map((speaker,index) => {
                let text = speaker.name + " - " + speaker.designation;

                const data = {
                  ...speaker,
                  key: index,
                  text: text,
                  value: uuid(),
                  description: ''
                };
                speakers_list.push(data);
              })
            }
          }
          this.setState({
            speaker_loader : false,
            speakers_list:speakers_list
          })
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.handleSearchSpeaker(e, { searchQuery });
          }
        });
    } else {
      this.setState({
        speakers_list: [],
        speaker_loader: false
      })
    }
  }

  handleSelectSpeaker = (e,{value}) => {
    let data = this.state.speakers_list;
    let selectedSpeaker = null;
    data.map((speaker,index) => {
      if (speaker.value === value) {
        selectedSpeaker = speaker;
      }
    });

    if (selectedSpeaker) {
      // console.log(selectedSpeaker);
      if (selectedSpeaker.value !== 0) {
        this.setState({
          search_speaker_name: value,
          speaker_id: selectedSpeaker.speaker_id,
          speaker_linkedin_url: selectedSpeaker.linkedin_url? selectedSpeaker.linkedin_url : "",
          speaker_designation: selectedSpeaker.designation? selectedSpeaker.designation : "",
          speaker_img: selectedSpeaker.image_url !== null ? selectedSpeaker.image_url : "",
          speaker_name: selectedSpeaker.name,
          valid_linkedin_url: false,
          speaker_linkedin_url_search: "",
          speaker_summary: selectedSpeaker.speaker_summary? selectedSpeaker.speaker_summary : "",
          speaker_name_field_disabled: false
        })
      } else {
        this.setState({
          search_speaker_name: selectedSpeaker.value,
          speaker_id: 0,
          speaker_linkedin_url: "",
          speaker_designation: "",
          speaker_img: "",
          speaker_name: selectedSpeaker.text,
          valid_linkedin_url: false,
          speaker_linkedin_url_search: "",
          speaker_summary: "",
          speaker_name_field_disabled: true
        })
      }
    }

  }

  render() {
    console.log(this.state.speaker_img);

    let {speaker_loader,speakers_list,search_speaker_name,speaker_name_field_disabled,isHiddenSpeakerSearch} = this.state;

    //following codes use to convert start time and end time into suitable objects which can set to date piker and time picker
    let dateRange = null;
    let s_time = null;
    let e_time = null;
    let ss_date = null;
    let ee_date = null;

    if (this.state.start_date !== "") {

      let startdate = this.state.start_date;
      let enddate = this.state.end_date;
      dateRange = [moment(startdate), moment(enddate)];
      ss_date = moment(startdate);
      ee_date = moment(enddate);

    } else {
      ss_date = null;
      ee_date = null;
      dateRange = null;

    }

    if (this.state.start_time !== "") {

      let starttime = this.state.start_time;
      s_time = moment(starttime, "HH:mm:ss");

    } else {

      s_time = null;

    }

    if (this.state.end_time !== "") {

      let endtime = this.state.end_time;
      e_time = moment(endtime, "HH:mm:ss");

    } else {

      e_time = null;

    }



    //folowing codes use to fill speaker table
    let speaker_rows = [];
    if (this.state.speakers !== 0) {
      this.state.speakers.map((value, index) => {
        speaker_rows.push({
          image: <img src={value.speaker_profile.image_url} width="45px"/>,
          name: value.speaker_profile.name,
          designation: value.speaker_profile.designation,
          linkedInUrl: value.linkedin_url,
          action: <div>
            <SementicBtn
              className="btncircular"
              circular icon='edit alternate'
              onClick={() => this.modifySpeaker(value, index)}/>
            <SementicBtn
              className="btncircular btn_trush cus-btn"
              circular icon='trash alternate'
              onClick={() => this.deleteSpeaker(index, value)}/>
          </div>
        });
      });
    }
    let speaker_columns = this.props.speaker_columns.columns;

    let colindex = 0;
    let cilSet1 = [];
    let cilSet2 = [];
    if (this.state.attachments !== 0) {
      this.state.attachments.map((obj, index) => {
        if (colindex === 0) {
          let el = <MiniUploderFrame name={obj.name} file={obj.file} blink={obj.link} index={index}
                                     remove={this.attachRemove}/>;
          cilSet1.push(el);
          colindex = 1;
        } else {
          let el = <MiniUploderFrame name={obj.name} file={obj.file} blink={obj.link} index={index}
                                     remove={this.attachRemove}/>;
          cilSet2.push(el);
          colindex = 0;
        }
      });
    }

    return (
      <div>
        <MDBModal isOpen={true} toggle={this.toggle} size="xl">
          <MDBModalHeader className={"title"} toggle={this.props.closeModal}>Agenda Session</MDBModalHeader>
          <MDBModalBody>

            <Row style={{paddingLeft: '20px',paddingRight: '20px'}}>
              <Col lg={12} style={{padding: '16px'}}>

                <Row>
                  <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>

                    <Card>
                      <CardHeader>
                        Session Details
                      </CardHeader>

                      <Collapse isOpen={true} id="collapseExample">

                        <CardBody>
                          <Row style={{padding: '10px'}}>
                            <Col lg={12}>
                              <Row style={{padding: '10px'}}>

                                <Col lg={6}>
                                  {/*<Row>*/}
                                  {/*  <Col lg={12}>*/}
                                  {/*    <Lbl required>Session Date</Lbl>*/}
                                  {/*    <RangePicker*/}
                                  {/*      size={"mini"}*/}
                                  {/*      disabledDate={disabledDate}*/}
                                  {/*      format="YYYY-MM-DD"*/}
                                  {/*      value={dateRange}*/}
                                  {/*      onChange={this.dateRangeOnChange}*/}
                                  {/*    />*/}
                                  {/*  </Col>*/}
                                  {/*</Row>*/}

                                  <Form>
                                    <Row className="TimePickerRow" style={{marginTop:"0px"}}>
                                      <Col lg={6} className="TimePickerCol">
                                        <Lbl required>Session Start Date</Lbl>
                                        <DatePicker format="YYYY-MM-DD" value={ss_date}
                                                    disabledDate={disabledDate}
                                                    onChange={this.dateOnChangeStart}/>
                                      </Col>
                                      <Col lg={6} className="TimePickerCol">
                                        <Lbl required>Session Start Time</Lbl>
                                        <ModernTimePicker
                                          unic= {"S"}
                                          time={ this.state.start_time }
                                          change={ this.startTimeOnChange }
                                          visible= {this.state.s_visible}
                                          visi= { this.clockVisibleChanger } />
                                      </Col>
                                    </Row>

                                    <Row className="TimePickerRow">
                                      <Col lg={6} className="TimePickerCol">
                                        <Lbl required>Session End Date</Lbl>
                                        <DatePicker format="YYYY-MM-DD" value={ee_date}
                                                    disabledDate={disabledDate}
                                                    onChange={this.dateOnChangeEnd}/>
                                      </Col>
                                      {/*<Col lg={1}></Col>*/}
                                      <Col lg={6}>
                                        <Lbl required>Session End Time</Lbl>
                                        {/*<TimePicker*/}
                                        {/*  format="HH:mm"*/}
                                        {/*  value={e_time}*/}
                                        {/*  onChange={this.endTimeOnChange}*/}
                                        {/*/>*/}
                                        <ModernTimePicker
                                          unic= {"E"}
                                          time={ this.state.end_time }
                                          change={ this.endTimeOnChange }
                                          visible= {this.state.e_visible}
                                          visi= { this.clockVisibleChanger } />
                                      </Col>
                                    </Row>

                                  </Form>
                                </Col>

                                <Col lg={6}>
                                  <Form>
                                    <Col className={"none-padding"} lg={12}>
                                      <Lbl required>Title</Lbl>
                                      <LabelInput
                                        placeholder={"Title"}
                                        value={this.state.name}
                                        onChange={this.onchangeHandler('name')}
                                      />
                                    </Col>

                                    <Col className={"none-padding sp-margin"} lg={12}>
                                      <Form.Group widths='equal'>
                                        <TxtAreaLbl
                                          required
                                          tagText={"Description"}
                                          placeholder={"Description"}
                                          value={this.state.description}
                                          onChange={this.onchangeHandler('description')}
                                        />
                                      </Form.Group>
                                    </Col>

                                  </Form>
                                </Col>

                                <Col lg={12}>
                                  <MiniFileUploader sendFiles={this.setPdf} btnName={"Upload Attachments"}
                                                    preview={[]}/>
                                  <Row>
                                    <Col md={12} lg={6}>
                                      {cilSet1}
                                    </Col>
                                    <Col md={12} lg={6}>
                                      {cilSet2}
                                    </Col>
                                  </Row>
                                </Col>

                              </Row>
                            </Col>

                          </Row>

                        </CardBody>
                      </Collapse>
                    </Card>
                  </Col>

                  <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
                    <Card>
                      <CardHeader>
                        Speakers
                      </CardHeader>
                      <Collapse isOpen={true} id="collapseExample">
                        <CardBody>

                          <Row style={{padding: '16px'}}>
                            <Col lg={6}>
                              <Form>
                                <Row className={isHiddenSpeakerSearch ? 'search-name' : ''}>
                                  <Col lg={12}>
                                    <LabelDropdown
                                      className={'cmbSpeakerSearch'}
                                      lblWidth={'85px'}
                                      loading={speaker_loader}
                                      btnText={"Get Info"}
                                      tagText={'Search'}
                                      placeholder={'Speaker name'}
                                      options={speakers_list}
                                      value={search_speaker_name}
                                      onSearchChange={this.handleSearchSpeaker}
                                      onChange={this.handleSelectSpeaker}
                                    />
                                  </Col>
                                </Row>
                                <Row className={"sp-margin"}>
                                  <Col lg={12}>
                                    <LabelInput
                                      tagText={"Speaker's LinkedIn URL"}
                                      placeholder={"Speaker's LinkedIn URL"}
                                      value={this.state.speaker_linkedin_url}
                                      onChange={this.onchangeHandler('speaker_linkedin_url')}
                                    />
                                  </Col>
                                </Row>
                                <Row className={"sp-margin"}>

                                  <Col lg={6}>
                                    {/*<Form.Group widths='equal'>*/}
                                      <Lbl required marginTop={'0'}>Speaker Name</Lbl>
                                      <LabelInput
                                        disable={speaker_name_field_disabled}
                                        className={speaker_name_field_disabled ? 'speaker_name' : ''}
                                        placeholder={"Speaker Name"}
                                        value={this.state.speaker_name}
                                        onChange={this.onchangeHandler('speaker_name')}
                                      />
                                    {/*</Form.Group>*/}
                                  </Col>
                                  <Col lg={6}>
                                    <Form.Group widths='equal'>
                                      <LabelInput
                                        required
                                        className={'speaker_designation'}
                                        tagText={"Speaker Designation"}
                                        placeholder={"Speaker Designation"}
                                        value={this.state.speaker_designation}
                                        onChange={this.onchangeHandler('speaker_designation')}
                                      />
                                    </Form.Group>
                                  </Col>

                                </Row>

                                <Row>
                                  <Col lg={12}>
                                    <Form.Group widths='equal'>
                                      <TxtAreaLbl
                                        required
                                        tagText={"Speaker Summary"}
                                        placeholder={"Speaker Summary"}
                                        value={this.state.speaker_summary}
                                        onChange={this.onchangeHandler('speaker_summary')}
                                      />
                                    </Form.Group>
                                  </Col>

                                </Row>
                              </Form>

                            </Col>

                            <Col lg={6}>
                              <Col xs="12" lg={"12"} md={"12"} className="textAlignCenter">
                                <Lbl required>Speaker Image</Lbl>
                                <CropImageUploader propName="speaker" image={this.state.speaker_img}
                                                   getImage={this.setSpeakerImg}/>
                              </Col>
                            </Col>

                          </Row>

                          <Row>
                            {
                              !this.state.speaker_edit ?
                                <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                                  <Button
                                    className="px-5"
                                    onClick={this.addSpeakerValidations}
                                  >Add Into Queue</Button>
                                </Col> :
                                <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                                  <Button
                                    className="px-5"
                                    onClick={this.addSpeakerValidations}
                                  >Update Speaker</Button>
                                  <SementicBtn
                                    className="btncircular"
                                    circular icon='redo'
                                    onClick={() => this.cleanSpeakerFields()}/>
                                </Col>
                            }
                          </Row>

                          {this.state.speakers.length !== 0 ?
                            <Row>
                              <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                                <Spin spinning={false} delay={10}
                                      indicator={<AntdIcon type="loading" style={{fontSize: 24}} spin={"true"}/>}>
                                  <MDBDataTable
                                    searching={false}
                                    displayEntries={false}
                                    paging={false}
                                    entries={0}
                                    responsive
                                    responsiveSm
                                    responsiveMd
                                    responsiveLg
                                    responsiveXl
                                    bordered
                                    hover
                                    columns={speaker_columns}
                                    rows={speaker_rows}/>
                                </Spin>
                              </Col>
                            </Row> : ""
                          }

                        </CardBody>
                      </Collapse>
                    </Card>
                  </Col>

                </Row>
                <Row>
                  <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                    {
                      this.state.session_id === 0 ?
                        <Button
                          className="btnSaveClose"
                          disabled={this.props.etvalid}
                          onClick={() => this.validateSession(1, "CLOSE")}
                        >Save and Close</Button> :
                        <Button
                          className="btnSaveClose"
                          disabled={this.props.etvalid}
                          onClick={() => this.validateSession(2, "CLOSE")}
                        >Update and Close</Button>
                    }

                    {
                      this.state.session_id === 0 ?
                        <Button
                          className="px-5"
                          disabled={this.props.etvalid}
                          onClick={() => this.validateSession(1, "CONTINUE")}
                        >Save and add new</Button> :
                        <Button
                          disabled={this.props.etvalid}
                          className="px-5"
                          onClick={() => this.validateSession(2, "CONTINUE")}
                        >Update and add new</Button>
                    }

                  </Col>
                </Row>
              </Col>
            </Row>
          </MDBModalBody>
        </MDBModal>
      </div>

    );

  }

}

const mapStateToProps = (state) => ({
  current_event: state.eventReducer.current_event,
  speaker_columns: state.eventPublicSpeakerReducer.Event_Public_Speaker_Table_data,
  agenda_columns: state.agendaEventReducer.Agenda_Table_data,
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {

  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
